module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img19.861c5932.jpg";